import { CardWidget } from '@/components/ui/card-widget';
import { useAtomValue } from 'jotai';
import { selectedClientAtom } from '@/state/clients/atoms';

export const Controls = () => {
  const selectedClient = useAtomValue(selectedClientAtom);
  return (
    <CardWidget>
      <h3 className="text-lg font-semibold mb-4">Controls</h3>
      <div className="flex flex-col gap-3">
        <div className="text-sm text-gray-600">
          <p>Stream Status: {selectedClient?.stream_status || 'Unknown'}</p>
          <p>Client: {selectedClient?.client_name || 'None selected'}</p>
        </div>
      </div>
    </CardWidget>
  );
};
